<template>
  <svg
    class="app-cookie-policy-manager-option-switcher"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="18"
    viewBox="0 0 32 18"
    fill="none"
  >
    <rect width="32" height="18" rx="9" :fill="options.bgFill" />
    <circle :cx="options.cx" cy="9" r="6" fill="#fff" />
  </svg>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    options() {
      return {
        bgFill: this.value ? '#202020' : '#dadcde',
        cx: this.value ? 23 : 9,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.app-cookie-policy-manager-option-switcher {
  rect,
  circle {
    transition: all 0.2s;
  }
}
</style>
